<div class="container">
  <div class="container-content content d-flex direction-column">
    <div class="d-flex direction-column header-fix">
      <div class="content-search search d-flex align-top justify-space-between">
        <div class="search-field field d-flex align-center">
          <div class="field-input input align-center d-flex">
            <input
              class="input-box box"
              type="text"
                placeholder="Buscar por lote, parceiro, NF, contrato ou proposta"
              [formControl]="queryField"
              (change)="searchField(queryField.value)"
              (keyup.enter)="searchField(queryField.value)" />
            <app-svg-icon
              class="input-icon"
              width="15px"
              height="17px"
              color="white"
              src="assets/icons/search-icon.svg"
              alt="search">
            </app-svg-icon>
          </div>
          <div class="cotainer-filter d-flex">
            <div class="input-filter">
              <app-svg-icon
                src="../../../../assets/icons/filter-black-icon.svg "
                color="black"
                width="30px"
                height="20px"
                (click)="toggleFilter()">
              </app-svg-icon>
            </div>

            <div class="filters" [ngClass]="{ 'show-filters': showFilters }">
              <app-dash-filter
                class="filters mt-28"
                [filterOptions]="filter"
                [showFilters]="showFilters"
                [titleComponent]="title"
                [mode]="mode">
              </app-dash-filter>
            </div>
          </div>
        </div>

        <div class="search-date date d-flex direction-column row-gap-10 plr-15">
          <span class="d-flex date-title">Data do Lote
            <div class="ml-6 pointer" role="button" tabindex="0" (click)="resetDateValue()"
              (keydown.enter)="resetDateValue()" (keydown.space)="resetDateValue()">
              <app-svg-icon
                src="assets/icons/reload-icon.svg"
                width="16px"
                height="16px"
                color="primary"></app-svg-icon>
            </div>
          </span>
          <div class="d-flex column-gap-5 pb-15 align-flex-end">
            <app-c-input
              [formControl]="batchDateFrom"
              inputType="date"
              class="form-input flex-1"
              label="Inicio:">
            </app-c-input>

            <app-c-input
              [formControl]="batchDateTo"
              inputType="date"
              class="form-input flex-1"
              label="Fim:">
            </app-c-input>

            <button class="date-btn" (click)="searchDateField()">
              <app-svg-icon
                class="input-icon"
                width="13px"
                height="13px"
                color="white"
                src="assets/icons/search-icon.svg"
                alt="search">
              </app-svg-icon>
            </button>

            <button class="date-btn" (click)="exportToClipboardTransfer()" *ngIf="showClipboardCopyTransfer">
              <app-svg-icon
                class="input-icon"
                width="13px"
                height="13px"
                color="white"
                src="assets/icons/download-icon.svg"
                alt="search">
              </app-svg-icon>
            </button>

            <button class="date-btn" (click)="exportToClipboardInvoicing()" *ngIf="!showClipboardCopyTransfer">
              <app-svg-icon
                class="input-icon"
                width="13px"
                height="13px"
                color="white"
                src="assets/icons/download-icon.svg"
                alt="search">
              </app-svg-icon>
            </button>

          </div>
        </div>

        <div class="d-flex align-center">
          <ng-container *ngIf="mode === Mode.Transfer; else invoicingActions">
            <div class="pr-20 d-flex align-center column-gap-8">
              <button
                type="button"
                class="search-btn d-flex justify-center align-center"
                [disabled]="!canSendTransferEmail"
                (click)="handleSendInvoiceEmail(false)">
                <app-svg-icon
                  src="../../../../assets/icons/email-icon.svg"
                  color="secondary"
                  width="18px"
                  height="18px">
                </app-svg-icon>
                <span class="ml-10">Enviar e-mail</span>
              </button>
              <button
                type="button"
                class="search-btn d-flex justify-center align-center"
                [disabled]="!canSendTransferPaymentEmail"
                (click)="handleSendInvoiceEmail(true)">
                <app-svg-icon
                  src="../../../../assets/icons/email-icon.svg"
                  color="secondary"
                  width="18px"
                  height="18px">
                </app-svg-icon>
                <span class="ml-10">Enviar e-mail Pgto</span>
              </button>
            </div>

            <div class="btn-create d-flex align-center">
              <button type="button"
                class="search-btn"
                [disabled]="isLoadingAutomatic"
                (click)="handleProcessAutomaticTransferBatches()">
                Gerar lote automático
              </button>
              &nbsp;&nbsp;&nbsp;
              <button type="button"
                class="search-btn"
                (click)="insertManualBatch()">
                Criar novo lote
              </button>
            </div>
          </ng-container>

          <ng-template #invoicingActions>
            <div *ngIf="mode === Mode.Invoicing" class="pr-20 d-flex align-center column-gap-8">
              <button
                type="button"
                class="search-btn d-flex justify-center align-center"
                [disabled]="!canSendInvoicingEmail"
                (click)="handleSendInvoiceEmail(false)">
                <app-svg-icon
                  src="../../../../assets/icons/email-icon.svg"
                  color="secondary"
                  width="18px"
                  height="18px">
                </app-svg-icon>
                <span class="ml-10">Enviar e-mail</span>
              </button>
            </div>
          </ng-template>
        </div>
      </div>
      <div>
        <app-ordered-header-list
          [headerItems]="headerItems"
          (orderChangeEvent)="orderChange($event)">

          <ng-container *ngIf="mode === Mode.Invoicing || mode === Mode.Transfer" headerFlag>
            <div class="flex-1 content-flag" style="text-align:left">#</div>
            <div class="flex-1 content-flag">
              <app-c-checkbox
                [checked]="checkAll"
                [disabled]="lotsList.length === 0"
                [controlDisabled]="lotsList.length === 0"
                [id]="'all'"
                (change)="changeInvoiceHeaderCheckbox()"></app-c-checkbox>
            </div>
          </ng-container>

        </app-ordered-header-list>
      </div>
    </div>
    <div class="content-lotes lotes d-flex direction-column row-gap-8 mt-8">
      <ng-container *ngFor="let lote of lotsList; let i = index">
        <app-card-lotes [lote]="lote" [tabType]="'solicitado'" [mode]="mode">
          <ng-container cardFlag>
            <div class="flex-1 content-flag">{{i+1}}</div>
            <div class="flex-1 content-flag">
              <app-c-checkbox
                [checked]="checkCardFlag(lote)"
                [disabled]="disabledCardFlag(lote)"
                [id]="lote.BatchId"
                [controlDisabled]="disabledCardFlag(lote)"
                (change)="changeInvoiceCardCheckbox(lote.BatchId.toString())"></app-c-checkbox>
            </div>
          </ng-container>
        </app-card-lotes>
      </ng-container>
      <div *ngIf="lotsList.length === 0" class="contracts-empty empty">
        <span class="empty-message"> Não há lotes disponíveis </span>
      </div>
      <ng-container *ngIf="count > lotsList.length">
        <app-scroll-pagination
          [count]="count"
          (viewMoreTrigger)="handlePagination($event)"></app-scroll-pagination>
      </ng-container>
    </div>
  </div>
</div>
